import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'
import "react-datepicker/dist/react-datepicker.css";

import CreateEditSow from './CreateEditSow'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchSowsList,
    fetchSowError,
    errorSow,
    deleteProject,
    exportProject,
    createProjectTab,
    updateProjectTab,
    fetchSowAnswers
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Sows.css'
import { setTimeout } from 'timers';

var Spinner = require('react-spinkit');

let chkReturn = 0;

class Sows extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editSowMode: false,

            curTemplate: 0,

            designFilter: "All",
            projectFilter: "",

            sortBy: "",
            sortOrder: "Ascending"
        };

        this.fetchSowErrorClear = this.fetchSowErrorClear.bind(this);
        this.errorSowClear = this.errorSowClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.projectEdit = this.projectEdit.bind(this);
        this.projectEditVerify = this.projectEditVerify.bind(this);

        this.sowCreate = this.sowCreate.bind(this);

        this.initSel = this.initSel.bind(this);

        this.updateTab = this.updateTab.bind(this);

        this.cancelSow = this.cancelSow.bind(this);
        this.closeTab = this.closeTab.bind(this);

        this.selectTemplate = this.selectTemplate.bind(this);

        this.sortColumn = this.sortColumn.bind(this);

        this.viewToggle = this.viewToggle.bind(this);

        this.filterDesigners = this.filterDesigners.bind(this);
        this.filterProjects = this.filterProjects.bind(this);

        this.projectExport = this.projectExport.bind(this);

        this.projectDelete = this.projectDelete.bind(this);
        this.projectDeleteVerify = this.projectDeleteVerify.bind(this);

        this.confirmDeleteNo = this.confirmDeleteNo.bind(this);
        this.confirmDeleteYes = this.confirmDeleteYes.bind(this);

        this.confirmChangeNo = this.confirmChangeNo.bind(this);
        this.confirmChangeYes = this.confirmChangeYes.bind(this);

        this.requestCancel = this.requestCancel.bind(this);
        this.confirmCancelNo = this.confirmCancelNo.bind(this);
        this.confirmCancelYes = this.confirmCancelYes.bind(this);
    }

    componentDidMount() {
        if (window.location.pathname.toLowerCase() !== '/prod-mgmt/sowslist') {
            let pathParts = window.location.pathname.split('/')
            let id = pathParts[pathParts.length - 1]

            let type_ndx
            let type = this.props.sows.sowsList.projects.filter((proj) => { return proj.projectID == id })[0].projectTypeID

            this.props.sows.templatesList.map((template, ndx) => {
                if (template.projectTypeID == type)
                    type_ndx = ndx
            })

            this.setState(
                {
                    editSow: true,
                    editSowExtra: true,
                    curTemplate: type_ndx
                }
            )

            fetchSowAnswers.bind(this)(id, this.props.sows.templatesList.filter((projtype) => { return projtype.projectTypeID == type })[0].projectTabs.length)

            chkReturn = setInterval(this.projectEditVerify, 100);
        }
        else {
            var _this = this

            chkReturn = setInterval(function () {
                if (_this.props.sows.fetchedUserInfo || _this.props.sows.errorUserInfo) {
                    if (_this.props.sows.fetchedUserInfo) {
                        if (_this.props.sows.sowsList.designers.filter((dsnr) => { return dsnr.fullName == _this.props.sows.userFullName }).length) {
                            $('select#designer_filter').val(_this.props.sows.user)
                            _this.setState({ designFilter: _this.props.sows.user })
                        }
                    }

                    clearInterval(chkReturn)
                    chkReturn = 0
                }
            }, 100)
        }
    }

    fetchSowErrorClear() {
        this.props.dispatch(fetchSowError);
    }

    errorSowClear() {
        this.props.dispatch(errorSow);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    afterOpen() {
        $('div.viewtab').css('display', 'none')
    }

    projectEdit(e) {

        if (chkReturn || this.props.sows.fetching) return;
        chkReturn = 1;

        let proj = e.target.attributes.proj.value;
        let type = e.target.attributes.type.value;

        let type_ndx

        this.props.sows.templatesList.map((template, ndx) => {
            if (template.projectTypeID == type)
                type_ndx = ndx
        })

        this.setState({
            editSow: true,
            curTemplate: type_ndx
        });

        fetchSowAnswers.bind(this)(proj, this.props.sows.templatesList.filter((projtype) =>
            { return projtype.projectTypeID == type })[0].projectTabs.length)

        chkReturn = setInterval(this.projectEditVerify, 100);
    }
    projectEditVerify() {
        if (this.props.sow.updated || this.props.sow.error) {
            if (this.props.sow.updated) {
                this.setState({ editSowMode: true });

                var _this = this
                setTimeout(function () {
                    var tab = 0
                    if (_this.props.sow.answers.lastTabCompleted) {
                        _this.props.sows.templatesList[_this.state.curTemplate].projectTabs.map((proj, index) => {
                            if (proj.projectTabId == _this.props.sow.answers.lastTabCompleted)
                                tab = index + 1                               
                        })

                        $('div.viewtab_hdr').each(function () {
                            if ($(this).attr('tabindex') > tab)
                                $(this).css('background', 'lightgray')
                        })
                    }

                    $('i[tabindex=' + tab + ']').removeClass('fa-toggle-down')
                    $('i[tabindex=' + tab + ']').addClass('fa-toggle-up')

                    $('div.viewtab[tabindex=' + tab + ']').css('display', 'block')

                    var error = false

                    $('[tabindex="' + tab + '"]').each(function () {
                        if ($(this).attr('required') && !$(this).hasClass('questlabel') && $(this).val().length == 0)
                            error = true
                        else if ($(this).attr('required') && $(this).hasClass('questlabel')) {
                            var oneSelected = false
                            var quest = $('label[tabindex="' + tab + '"]').text().split('*')[0]

                            if ($('input[type="checkbox"][tabindex="' + tab + '"][name="' + quest + '"]').length) {
                                $('input[type="checkbox"][tabindex="' + tab + '"][name="' + quest + '"]').each(function () {
                                    if ($(this).prop('checked'))
                                        oneSelected = true
                                })
                            }
                            else if ($('input[type="radio"][tabindex="' + tab + '"][name="' + quest + '"]').length) {
                                $('input[type="radio"][tabindex="' + tab + '"][name="' + quest + '"]').each(function () {
                                    if ($(this).prop('checked'))
                                        oneSelected = true
                                })
                            }
                            else if ($('select[tabindex="' + tab + '"][name="' + quest + '"]').length) {
                                if ($('select[tabindex="' + tab + '"][name="' + quest + '"]').val() != 'Select')
                                    oneSelected = true
                            }
                            else
                                oneSelected = true

                            if (!oneSelected)
                                error = true
                        }
                    })

                    if (error)
                        $('button[tabindex="' + tab + '"]').attr('disabled', 'disabled')
                    else
                        $('button[tabindex="' + tab + '"]').removeAttr('disabled')

                    if (tab == 0) {
                        $('#instructions').html(_this.props.sows.templatesList[_this.state.curTemplate].instructions).text()
                    }

                    _this.setState({
                        curTab: tab,
                        numTabs: $('div.viewtab_hdr').length
                    })
                }, 50)
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    sowCreate() {
        if (this.props.sows.fetching) return

        this.setState({
            curTab: 0,
            curTemplate: 0,

            editSow: false,
            editSowMode: true
        });

        this.initSel()
    }

    selectTemplate(e) {
        this.setState({
            curTab: 0,
            confirmChange: true,
            nextTemplate: e.target.selectedIndex
        })
    }

    initSel() {
        var _this = this
        setTimeout(function () {
            $('div.viewtab').css('display', 'none')

            $('div.viewtab_hdr').each(function () {
                if ($(this).attr('tabindex') > 0)
                    $(this).css('background', 'lightgray')
            })

            $('i[tabindex=0]').removeClass('fa-toggle-down')
            $('i[tabindex=0]').addClass('fa-toggle-up')

            $('div.viewtab[tabindex=0]').css('display', 'block')

            var error = false

            $('[tabindex="0"]').each(function () {
                $(this).val("")

                if ($(this).attr('required') && !$(this).hasClass('questlabel')) {
                    error = true
                }
                else if ($(this).attr('required') && $(this).hasClass('questlabel')) {

                    var quest = $('label[tabindex="0"]').text().split('*')[0]

                    if ($('input[type="checkbox"][tabindex="0"][name="' + quest + '"]').length) {
                        $('input[type="checkbox"][tabindex="0"][name="' + quest + '"]').each(function () {
                            $(this).prop('checked', false)
                        })
                    }
                    else if ($('input[type="radio"][tabindex="0"][name="' + quest + '"]').length) {
                        $('input[type="radio"][tabindex="0"][name="' + quest + '"]').each(function () {
                            $(this).prop('checked', false)
                        })
                    }
                    else if ($('select[tabindex="0"][name="' + quest + '"]').length) {
                        $(this).val("Select")
                    }

                    error = true
                }
            })

            if (error)
                $('button[tabindex="0"]').attr('disabled', 'disabled')
            else
                $('button[tabindex="0"]').removeAttr('disabled')

            $('#instructions').html(_this.props.sows.templatesList[_this.state.curTemplate].instructions).text()

            _this.setState({ numTabs: $('div.viewtab_hdr').length })
        }, 50)
    }

    updateTab(e) {
        if (this.props.sow.updating)
            return

        $('button[tabindex=' + e.target.attributes.tabindex.value + ']').attr('disabled', 'disabled')

        var tab = {
            lastTabCompleted: e.target.attributes.tabid.value,
            version: !this.state.editSow ? 1.0 : this.props.sow.answers.version,
            createQuestionResults: [],
            createQuestionOptions: []
        }

        $('[tabindex=' + e.target.attributes.tabindex.value + ']').each(function () {
            if ($(this).attr('questionid') && $(this).val().length) {
                var question = {
                    questionID: $(this).attr('questionid'),
                    result: $(this).val()
                }

                tab.createQuestionResults.push(question)
            }

            if ($(this).attr('questionoptid') && $(this).prop('checked')) {
                var option = {
                    questionID: $(this).attr('questionoptid'),
                    questionOptionID: $(this).attr('optionid')
                }

                tab.createQuestionOptions.push(option)
            }

            if ($(this).attr('questionseloptid') && $(this).val() != 'Select') {
                var option = {
                    questionID: $(this).attr('questionseloptid'),
                    questionOptionID: $(this).val()
                }

                tab.createQuestionOptions.push(option)
            }
        })

        if (!this.state.editSow && e.target.attributes.tabindex.value == 0) {
            if ($('#projtypes').val() != undefined) {
                createProjectTab.bind(this)($('#projtypes').val(), tab);

                this.setState({ curProjType: $('#projtypes').val() })
            }
            else {
                createProjectTab.bind(this)(this.state.curProjType, tab);
            }

            fetchSowsList.bind(this)({
                user: this.props.sows.user,
                admin: this.props.sows.sowadmin
            })
        }
        else {
            var updateTab = {
                lastTabCompleted: tab.lastTabCompleted,
                version: tab.version,
                updateQuestionResults: tab.createQuestionResults,
                updateQuestionOptions: tab.createQuestionOptions
            }

            if (this.state.curTab == this.props.sows.templatesList[this.state.curTemplate].projectTabs.length - 1) {
                var newversion = parseFloat(updateTab.version) + 0.1;
                updateTab.version = newversion.toString();
                updateTab.lastTabCompleted = null;
            }

            updateProjectTab.bind(this)(!this.state.editSow ? this.props.sow.sow.projectID : this.props.sow.answers.projectID, updateTab);

            if (e.target.attributes.tabindex.value == 0) {
                var _this = this

                setTimeout(function () {
                    fetchSowsList.bind(_this)({
                        user: _this.props.sows.user,
                        admin: _this.props.sows.sowadmin
                    })
                }, 500)
            }
        }

        this.setState({ curTab: e.target.attributes.tabindex.value })

        chkReturn = setInterval(this.closeTab, 100);
    }

    cancelSow() {
        this.props.dispatch(errorSow);

        if (this.state.editSowExtra) {
            this.setState({
                editSow: false,
                editSowExtra: false
            })
            window.location.pathname = '/prod-mgmt/sowslist'
        }
        else {
            this.setState({
                editSowMode: false
            });
        }

        fetchSowsList.bind(this)({
            user: this.props.sows.user,
            admin: this.props.sows.sowadmin
        })
    }
    closeTab() {
        if (this.props.sow.updated || this.props.sow.error) {

            if (this.props.sow.updated) {
                var tab = this.state.curTab

                $('i[tabindex=' + tab + ']').removeClass('fa-toggle-up')
                $('i[tabindex=' + tab + ']').addClass('fa-toggle-down')

                $('div.viewtab[tabindex=' + tab + ']').css('display', 'none')

                $('button[tabindex=' + tab + ']').removeAttr('disabled')

                if (tab == 0) {
                    setTimeout(function () {
                        $('span#projname').text($($('input[tabindex="0"]')[0]).val())
                    }, 100)
                }

                tab++;

                if (tab < this.state.numTabs) {

                    $('div.viewtab_hdr[tabindex=' + tab + ']').css('background', '#a02923')

                    $('i[tabindex=' + tab + ']').removeClass('fa-toggle-down')
                    $('i[tabindex=' + tab + ']').addClass('fa-toggle-up')

                    $('div.viewtab[tabindex=' + tab + ']').css('display', 'block')

                    var error = false

                    $('[tabindex="' + tab + '"]').each(function () {
                        if ($(this).attr('required') && !$(this).hasClass('questlabel') && $(this).val().length == 0)
                            error = true
                        else if ($(this).attr('required') && $(this).hasClass('questlabel')) {
                            var oneSelected = false
                            var quest = $('label[tabindex="' + tab + '"]').text().split('*')[0]

                            if ($('input[type="checkbox"][tabindex="' + tab + '"][name="' + quest + '"]').length) {
                                $('input[type="checkbox"][tabindex="' + tab + '"][name="' + quest + '"]').each(function () {
                                    if ($(this).prop('checked'))
                                        oneSelected = true
                                })
                            }
                            else if ($('input[type="radio"][tabindex="' + tab + '"][name="' + quest + '"]').length) {
                                $('input[type="radio"][tabindex="' + tab + '"][name="' + quest + '"]').each(function () {
                                    if ($(this).prop('checked'))
                                        oneSelected = true
                                })
                            }
                            else if ($('select[tabindex="' + tab + '"][name="' + quest + '"]').length) {
                                if ($('select[tabindex="' + tab + '"][name="' + quest + '"]').val() != 'Select')
                                    oneSelected = true
                            }
                            else
                                oneSelected = true

                            if (!oneSelected)
                                error = true
                        }
                    })

                    if (error)
                        $('button[tabindex="' + tab + '"]').attr('disabled', 'disabled')
                    else
                        $('button[tabindex="' + tab + '"]').removeAttr('disabled')

                    this.setState({ curTab: tab })

                    if (tab == this.state.numTabs - 1)
                        fetchSowAnswers.bind(this)(this.props.sow.sow.projectID, tab)
                }
                else {
                    this.cancelSow();
                }
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    sortColumn(e) {
        let sortOrder
        let sortElement = e.target.children.length === 0 ? e.target.parentElement : e.target
        let sortBy = sortElement.id
        let sort = sortElement.children[0].className.split(' ')[1]

        if (sort === "fa-sort") {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }
        else if (sort === "fa-sort-asc") {
            sortOrder = "Descending"
            sortElement.children[0].className = "fa fa-sort-desc fa-xs"
        }
        else {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }

        this.setState(
            {
                sortBy: sortBy,
                sortOrder: sortOrder
            }
        );

        $('th').each(function () {
            if ($(this).attr('id') !== sortElement.id) {
                $(this).removeClass("sort")
                $($(this).children()[0]).removeClass("fa-sort-asc")
                $($(this).children()[0]).removeClass("fa-sort-desc")
                $($(this).children()[0]).addClass("fa-sort")
            }
        })

        sortElement.className = "sort"
    }

    viewToggle(e) {
        if (!this.state.editSow && e.target.attributes.tabindex.value > this.state.curTab)
            return

        if (e.target.className.includes('down')) {
            e.target.className = "fa fa-toggle-up pull-right"

            var tab = e.target.attributes.tabindex.value

            $('div.viewtab[tabindex=' + tab + ']').css('display', 'block')

            var error = false

            $('[tabindex="' + tab + '"]').each(function () {
                if ($(this).attr('required') && !$(this).hasClass('questlabel') && $(this).val().length == 0)
                    error = true
                else if ($(this).attr('required') && $(this).hasClass('questlabel')) {
                    var oneSelected = false
                    var quest = $('label[tabindex="' + tab + '"]').text().split('*')[0]

                    if ($('input[type="checkbox"][tabindex="' + tab + '"][name="' + quest + '"]').length) {
                        $('input[type="checkbox"][tabindex="' + tab + '"][name="' + quest + '"]').each(function () {
                            if ($(this).prop('checked'))
                                oneSelected = true
                        })
                    }
                    else if ($('input[type="radio"][tabindex="' + tab + '"][name="' + quest + '"]').length) {
                        $('input[type="radio"][tabindex="' + tab + '"][name="' + quest + '"]').each(function () {
                            if ($(this).prop('checked'))
                                oneSelected = true
                        })
                    }
                    else if ($('select[tabindex="' + tab + '"][name="' + quest + '"]').length) {
                        if ($('select[tabindex="' + tab + '"][name="' + quest + '"]').val() != 'Select')
                            oneSelected = true
                    }
                    else
                        oneSelected = true

                    if (!oneSelected)
                        error = true
                }
            })

            if (error)
                $('button[tabindex="' + tab + '"]').attr('disabled', 'disabled')
            else
                $('button[tabindex="' + tab + '"]').removeAttr('disabled')
        }
        else {
            e.target.className = "fa fa-toggle-down down pull-right"

            $('div.viewtab[tabindex=' + e.target.attributes.tabindex.value + ']').css('display', 'none')
        }
    }

    modValues(e) {
        var error = false
        var tab = e.target.attributes.tabindex.value


        $('span#projname').text($($('input[tabindex="0"]')[0]).val())

        $('[tabindex="' + tab + '"]').each(function () {
            if ($(this).attr('required') && !$(this).hasClass('questlabel') && $(this).val().length == 0)
                error = true
            else if ($(this).attr('required') && $(this).hasClass('questlabel')) {
                var oneSelected = false
                var quest = $('label[tabindex="' + tab + '"]').text().split('*')[0]

                if ($('input[type="checkbox"][tabindex="' + tab + '"][name="' + quest + '"]').length) {
                    $('input[type="checkbox"][tabindex="' + tab + '"][name="' + quest + '"]').each(function () {
                        if ($(this).prop('checked'))
                            oneSelected = true
                    })
                }
                else if ($('input[type="radio"][tabindex="' + tab + '"][name="' + quest + '"]').length) {
                    $('input[type="radio"][tabindex="' + tab + '"][name="' + quest + '"]').each(function () {
                        if ($(this).prop('checked'))
                            oneSelected = true
                    })
                }
                else if ($('select[tabindex="' + tab + '"][name="' + quest + '"]').length) {
                    if ($('select[tabindex="' + tab + '"][name="' + quest + '"]').val() != 'Select')
                        oneSelected = true
                }
                else
                    oneSelected = true

                if (!oneSelected)
                    error = true
            }
        })

        if (error)
            $('button[tabindex="' + tab + '"]').attr('disabled', 'disabled')
        else
            $('button[tabindex="' + tab + '"]').removeAttr('disabled')
    }

    filterDesigners(e) {
        this.setState({ designFilter: e.target.value })
    }

    filterProjects(e) {
        this.setState({ projectFilter: e.target.value })
    }

    projectExport(e) {
        if (this.props.sows.fetching) return

        exportProject.bind(this)(e.target.attributes.proj.value)
    }

    projectDelete(e) {
        if (this.props.sows.fetching) return

        this.setState({
            confirmDelete: true,
            projectid: e.target.attributes.proj.value
        })

    }
    projectDeleteVerify() {
        if (this.props.sows.fetched || this.props.sows.error) {

            if (this.props.sows.fetched) {
                fetchSowsList.bind(this)({
                    user: this.props.sows.user,
                    admin: this.props.sows.sowadmin
                })
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    confirmDeleteNo() {
        this.setState({ confirmDelete: false })
    }
    confirmDeleteYes() {
        deleteProject.bind(this)(this.state.projectid);

        chkReturn = setInterval(this.projectDeleteVerify, 100);

        this.confirmDeleteNo()
    }

    confirmChangeNo() {
        this.setState({ confirmChange: false })
        $('#projtypes').prop('selectedIndex', this.state.curTemplate)
    }
    confirmChangeYes() {
        this.setState({
            curTab: 0,
            confirmChange: false,
            curTemplate: this.state.nextTemplate
        })

        this.initSel()
    }

    requestCancel(e) {
        if (e.target.attributes.canc)
            this.cancelSow()
        else
            this.setState({ confirmCancel: true })
    }
    confirmCancelNo() {
        this.setState({ confirmCancel: false })
     }
    confirmCancelYes() {
        this.confirmCancelNo()
        this.cancelSow()
    }

    render() {
        return (
            <div className="sows col-xs-12">
                <CommError error={this.props.sows.error} onClose={this.fetchSowErrorClear} />

                <ConfirmModal open={this.props.sows.noData} heading={"Scope of Work"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />
                <ConfirmModal open={this.state.confirmDelete} heading={"Delete Project"} msg={"Are you sure you want to delete this project?"} onNo={this.confirmDeleteNo} onYes={this.confirmDeleteYes} />

                <div className="headWrapper">
                    <div className="sows">
                        <h1>Scope of Work</h1>
                    </div>
                    <div id="over768" className="col-xs-12 header">
                        <div className="col-xs-3">
                            <p>Designer:</p>
                            {
                                this.props.sows.fetching ?
                                    <select id="designer_filter" disabled defaultValue={this.props.sows.userFullName}>
                                        <option>All</option>
                                        {
                                            this.props.sowsList &&
                                                this.props.sowsList.designers &&
                                                this.props.sowsList.designers.length ?
                                                this.props.sowsList.designers.map((designer, index) => {
                                                    return <option key={index} value={designer.username}>{designer.fullName}</option>
                                                })
                                            : null
                                        }
                                    </select>
                                :
                                    <select id="designer_filter" onClick={this.filterDesigners} defaultValue={this.props.sows.userFullName}>
                                        <option>All</option>
                                        {
                                            this.props.sowsList &&
                                                this.props.sowsList.designers &&
                                                this.props.sowsList.designers.length ?
                                                this.props.sowsList.designers.map((designer, index) => {
                                                    return <option key={index} value={designer.username}>{designer.fullName}</option>
                                                })
                                            : null
                                        }
                                    </select>
                            }
                        </div>

                        <div className="col-xs-3">
                            <p>Project Name:</p>
                            {
                                this.props.sows.fetching ?
                                    <input disabled />
                                :
                                    <input onChange={this.filterProjects} spellCheck="false" />
                            }
                        </div>
                        <div className="col-xs-6">
                            <br />
                            <button className="btn btn-primary pull-right" onClick={this.sowCreate}>+ Create Scope of Work</button>
                        </div>
                    </div>
                    <div id="under768" className="col-xs-12 header">
                        <div className="col-xs-12">
                            <span>Designer:</span>
                            <select id="designer_filter" onClick={this.filterDesigners} defaultValue={this.props.sows.userFullName}>
                                <option>All</option>
                                {
                                    this.props.sowsList &&
                                        this.props.sowsList.designers &&
                                        this.props.sowsList.designers.length ?
                                        this.props.sowsList.designers.map((designer, index) => {
                                            return <option key={index} value={designer.username}>{designer.fullName}</option>
                                        })
                                        : null
                                }
                            </select>
                        </div>

                        <div className="col-xs-12">
                            <span>Project Name:</span>
                            <input onChange={this.filterProjects} spellCheck="false" />
                        </div>
                        <div className="col-xs-12">
                            <br />
                            <button className="btn btn-primary" onClick={this.sowCreate}>+ Create Scope of Work</button>
                        </div>
                    </div>
                </div>
                <div className="tableWrapper"> 
                    {
                        this.props.sows.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th>ID</th>
                                <th id="name" onClick={this.sortColumn}>Project Name<i className="fa fa-sort fa-xs"></i></th>
                                <th id="type" onClick={this.sortColumn}>Project Type<i className="fa fa-sort fa-xs"></i></th>
                                <th id="created" onClick={this.sortColumn}>Created On Date<i className="fa fa-sort fa-xs"></i></th>
                                <th id="modified" onClick={this.sortColumn}>Modifed On Date<i className="fa fa-sort fa-xs"></i></th>
                                <th id="designer" onClick={this.sortColumn}>Designer<i className="fa fa-sort fa-xs"></i></th>
                                <th id="revision">Revision #<i className="fa fa-sort fa-xs"></i></th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.sowsList && this.props.sowsList.projects && this.props.sowsList.projects.length ?
                                    this.props.sowsList.projects.filter((proj) => {
                                        if (this.state.designFilter == 'All')
                                            return true
                                        else
                                            return proj.designer == this.state.designFilter
                                    })
                                    .filter((proj) => {
                                        return this.state.projectFilter == '' ||
                                            proj.projectName.toLowerCase().includes(this.state.projectFilter.toLowerCase())
                                    })                        
                                    .sort((a, b) => {
                                        if (this.state.sortBy === 'name') {
                                            if (a.projectName > b.projectName)
                                                return this.state.sortOrder === 'Ascending' ? 1 : -1
                                            else if (a.projectName < b.projectName)
                                                return this.state.sortOrder === 'Ascending' ? -1 : 1
                                            else
                                                return 0
                                        }
                                        else if (this.state.sortBy === 'type') {
                                            if (a.projectType > b.projectType)
                                                return this.state.sortOrder === 'Ascending' ? 1 : -1
                                            else if (a.projectType < b.projectType)
                                                return this.state.sortOrder === 'Ascending' ? -1 : 1
                                            else
                                                return 0
                                        }
                                        else if (this.state.sortBy === 'created') {
                                            if (a.createdOnDate > b.createdOnDate)
                                                return this.state.sortOrder === 'Ascending' ? 1 : -1
                                            else if (a.createdOnDate < b.createdOnDate)
                                                return this.state.sortOrder === 'Ascending' ? -1 : 1
                                            else
                                                return 0
                                        }
                                        else if (this.state.sortBy === 'modified') {
                                            if (a.modifiedOnDate > b.modifiedOnDate)
                                                return this.state.sortOrder === 'Ascending' ? 1 : -1
                                            else if (a.modifiedOnDate < b.modifiedOnDate)
                                                return this.state.sortOrder === 'Ascending' ? -1 : 1
                                            else
                                                return 0
                                        }
                                        else {
                                            if (a.designer > b.designer)
                                                return this.state.sortOrder === 'Ascending' ? 1 : -1
                                            else if (a.designer < b.designer)
                                                return this.state.sortOrder === 'Ascending' ? -1 : 1
                                            else
                                                return 0
                                        }
                                    })
                                    .map((proj) => {
                                        if (this.state.projectFilter == '') {
                                            proj.match = false

                                            return proj
                                        }
                                        else if (proj.projectName.toLowerCase().includes(this.state.projectFilter.toLowerCase())) {
                                            proj.match = true
                                            proj.matchArray = proj.projectName.toLowerCase().split(this.state.projectFilter.toLowerCase())
                                            proj.matchlocation = proj.projectName.toLowerCase().indexOf(this.state.projectFilter.toLowerCase())
                                            proj.matchBegin = proj.matchArray[0].length == 0
                                            proj.matchEnd = proj.matchArray[1].length == 0

                                            if (proj.matchBegin) {
                                                proj.prefix = proj.projectName.substr(0, this.state.projectFilter.length)
                                                proj.suffix = proj.projectName.substr(this.state.projectFilter.length)
                                            }
                                            else if (proj.matchEnd) {
                                                proj.prefix = proj.projectName.substr(0, proj.matchlocation)
                                                proj.suffix = proj.projectName.substr(proj.matchlocation)
                                            }
                                            else  {
                                                proj.prefix = proj.projectName.substr(0, proj.matchlocation)
                                                proj.middle = proj.projectName.substr(proj.matchlocation, this.state.projectFilter.length)
                                                proj.suffix = proj.projectName.substr(proj.matchlocation + this.state.projectFilter.length)
                                            }
                                           
                                            return proj
                                        }
                                    })
                                    .map((proj, index) => {
                                        return <tr className="body" key={index}>
                                            <td>{proj.projectID}</td>
                                            {
                                                proj.matchBegin ?
                                                    <td className="name" proj={proj.projectID} type={proj.projectTypeID} onClick={this.projectEdit}><span className="filter">{proj.prefix}</span>{proj.suffix}</td>
                                                : proj.matchEnd ?
                                                    <td className="name" proj={proj.projectID} type={proj.projectTypeID} onClick={this.projectEdit}>{proj.prefix}<span className="filter">{proj.suffix}</span></td>
                                                : proj.match ?
                                                    <td className="name" proj={proj.projectID} type={proj.projectTypeID} onClick={this.projectEdit}>{proj.prefix}<span className="filter">{proj.middle}</span>{proj.suffix}</td>
                                                :
                                                    <td className="name" proj={proj.projectID} type={proj.projectTypeID} onClick={this.projectEdit}>{proj.projectName}</td>
                                            }
                                            <td>{proj.projectType}</td>
                                            <td>{proj.createdOnDateDisplay}</td>
                                            <td>{proj.modifiedOnDateDisplay}</td>
                                            <td>{proj.designer}</td>
                                            <td>{proj.version}</td>
                                            <td>
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                    <i className="fa fa-edit" proj={proj.projectID} type={proj.projectTypeID} onClick={this.projectEdit}></i>
                                                </OverlayTrigger>
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                                                    <i className="fa fa-remove" proj={proj.projectID} onClick={this.projectDelete}></i>
                                                </OverlayTrigger>
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Export to PDF</Tooltip>}>
                                                    <i className="fa fa-file-pdf-o" proj={proj.projectID} onClick={this.projectExport}></i>
                                                </OverlayTrigger>
                                            </td>
                                        </tr>
                                    })
                                : null
                            }
                        </tbody>
                    </table>
                </div>

                <CreateEditSow
                    errSow={this.props.sow}
                    errSowClear={this.errorSowClear}

                    curTemplate={this.state.curTemplate}
                    curTab={this.state.curTab}

                    templates={this.props.sows.templatesList}
                    answers={this.props.sow.answers}

                    selTemplate={this.selectTemplate}

                    modValues={this.modValues}
                    updateTab={this.updateTab}
                    saveProject={this.closeTab}
                    projectExport={this.projectExport}

                    create={this.state.editSow}
                    isOpen={this.state.editSowMode}

                    tabToggle={this.viewToggle}

                    confirmChange={this.state.confirmChange}
                    confirmChangeYes={this.confirmChangeYes}
                    confirmChangeNo={this.confirmChangeNo}      

                    confirmCancel={this.state.confirmCancel}
                    confirmCancelYes={this.confirmCancelYes}
                    confirmCancelNo={this.confirmCancelNo}      
        
                    onAfterOpen={this.afterOpen}
                    onRequestCancel={this.requestCancel}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    sow: state.sow,
    sows: state.sows
});

export default connect(mapStateToProps)(Sows)